import { Component, ElementRef, Self, ViewChild } from '@angular/core';
import { MatSelect } from '@angular/material/select';
import { MatTableDataSource } from '@angular/material/table';
import { LightReachModel } from '@api/models/finance.model';
import { AuthService } from '../../helpers/auth.service';
import { LiveAPIService } from 'src/app/services/api/quotes/liveAPI.service';

@Component({ standalone: false,
  selector: 'app-light-reach-aproved-hdw',
  templateUrl: './light-reach-aproved-hdw.component.html',
  styleUrls: ['./light-reach-aproved-hdw.component.scss']
})
export class LightReachAprovedHdwComponent {

  selectedType = { name: 'Module', value: 'panel' };

  typeOptions: { name: string; value: string }[] = [
    { name: 'Inverter', value: 'inverter' },
    { name: 'Module', value: 'panel' },
    { name: 'Racking', value: 'mounting' }
  ];
compareObjects = (o1: any, o2: any) => o1?.value === o2?.value;

  displayedColumns: string[] = ['name', 'manufacturer', 'model'];

  data: MatTableDataSource<LightReachModel> | any = [];
  filteredDataSource: MatTableDataSource<LightReachModel> | any = [];
  @ViewChild('filterInput') filterInput!: ElementRef;

  constructor(private liveApiService: LiveAPIService, private authService: AuthService) {

  }


  ngOnInit() {
    this.getLightReachData()
  }

  getLightReachData() {
    if (this.filterInput) {
      this.filterInput.nativeElement.value = '';
    }

    const params: any = {
      account_id: this.authService.getItem('account_id'),
      email_id: this.authService.getItem('email_id'),
      type: this.selectedType.value
    };
    this.liveApiService.getLightReachData(params).subscribe(response => {
      if (response.status === 'Success') {
        this.data = response.data;
        this.filteredDataSource = new MatTableDataSource(this.data)
      } else {
        console.error('Failed to fetch data:', response.error);
      }
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.filteredDataSource = this.data.filter((row: any) =>
      row.manufacturer.toLowerCase().includes(filterValue) ||
      row.modelNumber.toLowerCase().includes(filterValue) ||
      row.name.toLowerCase().includes(filterValue) // optional: include name
    );
  }

}
